// extracted by mini-css-extract-plugin
export var numpadContainer = "_m7-1";
export var phoneButton = "_m7-0";